<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      This is another dummy with value {{localValue}}
      <p>This one emits custom event on eventBus</p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        @click.prevent="handleAddClick"
        href="#"
      >Add +</v-btn>
      <v-btn
        color="secondary"
        @click.prevent="handleEmitClick"
        href="#"
      >Emit</v-btn>
    </v-card-actions>

  </v-card>
</template>
<script>
export default {
  name: 'DummyEventBus',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },

  methods: {
    handleAddClick () {
      this.localValue++
    },
    handleEmitClick (e) {
      this.$eventBus.$emit('CUSTOM_EVENT', {
        value: this.localValue,
        someProp: 'Test'
      })
    }
  }
}
</script>
